export default __webpack_public_path__ + "static/grow-your-email-list-5e93c3e94f7e78ed07ae9769af513752.svg";